module.exports = __webpack_public_path__ + "img/mo2.6a42c0d5.png";